import { api } from "@/lib/orgApi";

export async function getGenericReportTemplate() {
  const { data } = await api.get("/generic-report-template");
  return data;
}

export async function saveGenericReportTemplate(payload) {
  const { data } = await api.put("/generic-report-template", payload);
  return data;
}
